import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { PageSelectorService, PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { SmartAnnotationService, SmartAnnotationServiceSymbol } from '@/presentation/components/SmartAnnotation/SmartAnnotationService';
import { LinkJumpSelectService, LinkJumpSelectServiceSymbol } from '@/presentation/components/LinkJumpSettings/LinkJumpSelectService';
import { CollaborationService, CollaborationServiceSymbol } from '@/presentation/components/TheCollaboration/CollaborationService';
import { EditCustomFieldDialogService, EditCustomFieldDialogServiceSymbol } from '@/presentation/components/custom-field/EditCustomFieldDialogService';
import { FolderSelectorService, FolderSelectorServiceSymbol } from '@/presentation/components/folders/folderSelector/FolderSelectorService';
import { CopyMoveViewDataService, CopyMoveViewDataServiceSymbol } from '@/presentation/pages/detail/basic/service/CopyMoveViewDataService';
import { AsideFolderSearchService, AsideFolderSearchServiceSymbol } from '@/presentation/components/AsideFolderSearch/AsideFolderSearchService';
import { CopyFieldAndCommentsService, CopyFieldAndCommentsServiceSymbol } from '@/presentation/components/CopyFieldAndComments/CopyFieldAndCommentsService';
import { SortService, SortServiceSymbol } from '@/presentation/pages/detail/basic/service/SortService';
import { ColumnManageService, ColumnManageServiceSymbol } from '@/presentation/pages/detail/basic/service/ColumnManageService';
import { EditAiCustomFieldDialogService, EditAiCustomFieldDialogServiceSymbol, } from '@/presentation/components/ai-custom-field/EditAiCustomFieldDialogService';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { ErrorHandlerContribution, ErrorHandlerRegistry, ErrorHandlerRegistryImpl } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { PsHttp$, PsHttpChannel, PsHttpChannelImpl } from '@patsnap/tahiti-core/common/http-channel';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
export const infrastructure = new ContainerModule(bind => {
    bind(PageSelectorServiceSymbol).to(PageSelectorService);
    bind(SmartAnnotationServiceSymbol).to(SmartAnnotationService);
    bind(LinkJumpSelectServiceSymbol).to(LinkJumpSelectService);
    bind(CollaborationServiceSymbol).to(CollaborationService);
    bind(EditCustomFieldDialogServiceSymbol)
        .to(EditCustomFieldDialogService)
        .inTransientScope();
    bind(FolderSelectorServiceSymbol)
        .to(FolderSelectorService)
        .inTransientScope();
    bind(CopyMoveViewDataServiceSymbol).to(CopyMoveViewDataService);
    bind(AsideFolderSearchServiceSymbol).to(AsideFolderSearchService);
    bind(CopyFieldAndCommentsServiceSymbol).to(CopyFieldAndCommentsService);
    bind(SortServiceSymbol).to(SortService);
    bind(ColumnManageServiceSymbol).to(ColumnManageService);
    /**
     * 将 `EditAiCustomFieldDialogService` 绑定到 `EditAiCustomFieldDialogServiceSymbol` 上，并设置其作用域为临时作用域。
     * 这个绑定允许依赖注入容器在需要时创建 `EditAiCustomFieldDialogService` 的新实例。
     *
     * 参数无。
     * 返回值无。
     */
    bind(EditAiCustomFieldDialogServiceSymbol)
        .to(EditAiCustomFieldDialogService)
        .inTransientScope();
    bind(PsHttp).toConstantValue(psHttp);
    bind(PsHttp$).toConstantValue(psHttp$);
    bind(PsHttpChannel).to(PsHttpChannelImpl);
    bind(ErrorHandlerRegistry).to(ErrorHandlerRegistryImpl);
    bindContributionProvider(bind, ErrorHandlerContribution);
});
